import { c as _c } from "react/compiler-runtime";
import { selectCallstackFrameIndex } from "#/features/callstack/model/callstackSlice";
import { useAppSelector } from "#/store/hooks";
export const FrameIndexLabel = () => {
  const $ = _c(2);
  const frameIndex = useAppSelector(selectCallstackFrameIndex);
  let t0;
  if ($[0] !== frameIndex) {
    t0 = <span className="text-xs min-w-[3ch]">{frameIndex}</span>;
    $[0] = frameIndex;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};